if($('.value-calculator-one').length) {

    $('.value-calculator-one').each(function() {

        let stateInput = $(this).find('.select-state-input'),
            headcountInput = $(this).find('.headcount-input'),
            hourlyInput = $(this).find('.payrate-input'),
            hourlyInputUs = $(this).find('.payrate-us'),
            hourlyDisplay = $(this).find('.value-hourly'),
            valueBurdenDisplay = $(this).find('.value-burden'),
            valueBurden = 0.00,
            valueTotalExpensePerHourInHouse = $(this).find('.value-total-expense-per-hour'),
            valueBillRateDisplay = $(this).find('.value-bill-rate'),
            valueCostBenefitPerHour = $(this).find('.value-cost-benefit-per-hour'),
            valueAnnualSavingsPerAssociate = $(this).find('.value-annual-savings-per-associate'),
            valueHeadcount = $(this).find('.value-headcount'),
            valueAnnualSavingsTotal = $(this).find('.value-annual-savings-total'),
            ctaFormExpand = $(this).find('.cta-form-expand'),
            ctaFormContainer = $(this).find('.cta-form-container');

        ctaFormExpand.on('click', function() {
            ctaFormContainer.slideToggle(300, function() {
                // if(ctaFormContainer.is(':visible')) {
                //     ctaFormExpand.html('Hide Form');
                // } else {
                //     ctaFormExpand.html('Get Started');
                // }
            });
        });

        if(ctaFormContainer.length) {
            setTimeout(function() {
                ctaFormContainer.slideUp();
            }, 1000);
        }

        hourlyInput.on(('focusout'), function() {
            if($(this).val().indexOf('.') === -1) {
                $(this).val($(this).val() + '.00');
            }
        });

        stateInput.on('change', evaluate);
        headcountInput.on('input', evaluate);
        hourlyInput.on('input', evaluate);
        hourlyInputUs.on('input', evaluate);

        function evaluate() {
            let state = stateInput.val(),
                headcount = headcountInput.val(),
                hourlyRate = hourlyInput.val();

            if(typeof window.state_burdens[state] !== undefined) {

                hourlyDisplay.html(money(hourlyRate, true));

                valueHeadcount.html(headcount);

                let burdenPercentage = window.state_burdens[state].burden;

                burdenPercentage.replace('%', '');
                burdenPercentage = parseFloat(burdenPercentage) / 100;

                valueBurden = burdenPercentage * hourlyRate;
                valueBurden = valueBurden.toFixed(2);
                valueBurdenDisplay.html(money(valueBurden, true));

                let totalExpensePerHourInHouse = parseFloat(hourlyRate) + parseFloat(valueBurden);
                totalExpensePerHourInHouse = totalExpensePerHourInHouse + 3.65 + .82 + .85 + 1.98;
                valueTotalExpensePerHourInHouse.html(money(totalExpensePerHourInHouse, true));

                let billRate = hourlyRate * (window.markup + 1);
                valueBillRateDisplay.html(money(billRate, true));

                let costBenefitPerHour = totalExpensePerHourInHouse - billRate;
                valueCostBenefitPerHour.html(money(costBenefitPerHour, true));

                let savingsPerAssociate = costBenefitPerHour * 2080;
                valueAnnualSavingsPerAssociate.html(money(savingsPerAssociate, false));

                let totalSavings = savingsPerAssociate * headcount;
                valueAnnualSavingsTotal.html(money(totalSavings, false));

            }
        }

        evaluate();

    });

}

function money(value, showZeros) {
    let display = value.toLocaleString('en-US', {
        style: 'currency',
        currency: 'USD',
    });

    display = display.replace('$', '');

    if(!showZeros) {
        display = display.replace('.00', '');
    }

    let displaySplit = display.split('.');

    if(displaySplit.length === 2) {
        display = displaySplit[0] + '<span class="cents">' + displaySplit[1] + '</span>';
    } else {
        if(showZeros) {
            display = displaySplit[0] + '<span class="cents">00</span>';
        } else {
            display = displaySplit[0];
        }
    }

    return '$' + display;
}
